// Add "active" class to the nav pill when a menu item is active
document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".header__menu-item");
  const navPill = document.querySelector(".nav-pill");
  const navPillPadding = 0; // Adjust this value based on your design
  const allActiveMenuItems = document.querySelectorAll(
    ".header__menu-item .header__active-menu-item",
  );
  const activeMenuItem = allActiveMenuItems.length > 0 ? allActiveMenuItems[0] : null;
  const topLevelCat = localStorage.getItem("topLevelCat");

  // keep track of current handle class on the pill and update as needed
  function updateHandleClass(item) {
    if (item && !item.classList && !item.classList.contains("header__menu-item")) {
      item = item?.closest(".header__menu-item");
    }
    // remove any existing handle-specific modifier
    navPill.classList.forEach(c => {
      if (c.startsWith('color-bg-')) {
        navPill.classList.remove(c);
      }
    });

    if (item && item.dataset && item.dataset.handle) {
      const handle = item.dataset.handle;
      navPill.classList.add(`color-bg-${handle}`);
    }
  }

  const returnToActiveItem = () => {
    if (activeMenuItem || topLevelCat) {
      let item = null;
      if (topLevelCat && allActiveMenuItems.length > 1) {
        // If there are multiple possible active child links, use localStorage saved version
        item = document.querySelector(`.header__menu-item[data-handle="${topLevelCat}"]`)?.closest("li");
      } else {
        item = activeMenuItem.closest("li");
      }
      const itemOffsetLeft = item.offsetLeft - navPillPadding;
      const itemOffsetWidth = item.offsetWidth;

      navPill.style.width = `${itemOffsetWidth + navPillPadding * 2}px`;
      navPill.style.transform = `translateX(${itemOffsetLeft}px)`;
      navPill.style.opacity = 1;
      // update class based on handle if provided
      updateHandleClass(item);
    } else {
      navPill.style.opacity = 0;
      updateHandleClass(null);
    }
  }

  const header = document.querySelector(".header-wrapper");
  header.addEventListener("mouseleave", returnToActiveItem);

  function updateNavPill(event) {
    const target = event ? event.currentTarget : null;
    const activeItem = target || activeMenuItem;
    if (activeItem) {
      const itemOffsetLeft = activeItem.offsetLeft - navPillPadding;
      const itemOffsetWidth = activeItem.offsetWidth;

      navPill.style.width = `${itemOffsetWidth + navPillPadding * 2}px`;
      navPill.style.transform = `translateX(${itemOffsetLeft}px)`;
      navPill.style.opacity = 1;
      // update class based on current item handle
      updateHandleClass(activeItem);
    } else {
      navPill.style.opacity = 0;
      updateHandleClass(null);
    }
  }

  function updateTopLevelCat(event) {
    const headerMenu = event.target.closest("header-menu");
    const topLevelCat = headerMenu.querySelector(".header__menu-item");
    localStorage.setItem("topLevelCat", topLevelCat.dataset.handle);
  }

  menuItems.forEach((item) => {
    item.addEventListener("mouseover", updateNavPill);
    item.addEventListener("mouseout", updateNavPill);
  });

  const catLinks = document.querySelectorAll(".category-list__link");
  catLinks.forEach((item) => {
    item.addEventListener("click", updateTopLevelCat);
  });

  window.addEventListener('resize', returnToActiveItem);

  updateNavPill(); // Initial call to set position on page load
  returnToActiveItem(); // Ensure it returns to active item on load as well
});
